module.exports = __webpack_public_path__ + "static/media/maya_.a6842251.jpg";